export default "__VITE_ASSET__SnDs3h9w__"